<template>
  <div class="form-group theme-login-form-group theme-form-group">
    <label
      :for="`input-file-${_uid}`"
      class="theme-form-label">{{ label }}<template v-if="required">*</template></label>
    <div class="input-file form-control">
      <span
        :class="{ 'alert-danger': submitted && errors.has(name) }"
        class="placeholder">{{ textFile }}</span>
      <input
        :id="`input-file-${_uid}`"
        v-validate="required ? validate : ''"
        :name="name"
        :disabled="disabled"
        @change="handleUpload"
        :accept="accept"
        type="file" />
    </div>
    <span
      v-if="submitted && errors.has(name)"
      class="theme-form-error-message">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
export default {
  inject: [ '$validator' ],
  props: [
    'label',
    'required',
    'name',
    'validate',
    'submitted',
    'file',
    'disabled',
    'accept'
  ],
  data () {
    return {
      textFile: 'Escolha o arquivo'
    }
  },
  methods: {
    handleUpload (event) {
      const file = event.target.files[0]
      const formData = new FormData()
      formData.append(this.name, file)

      if (file.name) {
        this.textFile = file.name
      } else {
        this.textFile = 'Escolha o arquivo'
      }

      if (file) {
        this.$emit('input', formData)
      }
    }
  }
};
</script>
